<template>
  <div class="columns form-wrapper">
    <loader :loading="loading" :fixed="false"></loader>
    <form class="column is-12">
      <div class="field">
        <label class="label">{{ $resx("General.Settings.Email") }}</label>
        <div class="control">
          <input class="input" type="text" :disabled="true" v-model="settings.Email" />
        </div>
      </div>
      <div class="field cultures">
        <label class="label">{{ $resx("General.Settings.Cultures") }}</label>
        <span v-for="(culture, idx) in cultures.selected" :key="idx" @click="deleteCulture(idx)">
          <span :class="['flag flag-xs flag-'+idx.split('-')[1].toLowerCase()]"></span>
          <font-awesome-icon :icon="icons.trash"/>
        </span>
        <div class="field has-addons">
          <div class="control">
            <div class="select">
              <select v-model="cultureValue">
                <option v-for="(culture, idx) in cultures.available" :key="idx" :value="idx">{{ culture.EnglishName }}</option>
              </select>
            </div>
          </div>
          <div class="control">
            <a class="button is-primary" disabled @click="selectCulture">
              Add
            </a>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import loader from '@/components/Loader.vue'
import { confirm } from '@/mixins/confirm.js'
import { faTimes } from '@fortawesome/pro-regular-svg-icons'

export default {
  name: 'modalContentSettings',
  data () {
    return {
      loading: false,
      cultureValue: '',
      settings: {
        Email: ''
      },
      icons: {
        trash: faTimes
      }
    }
  },
  components: {
    loader
  },
  mixins: [confirm],
  mounted () {
    this.$store.dispatch('getAvailableCultures')
  },
  computed: {
    cultures () {
      var self = this
      var tmp = {
        selected: {},
        available: {}
      }
      for (var key in self.$store.state.availableCultures) {
        if (!self.$store.state.availableCultures[key].Selected) {
          tmp.available[key] = self.$store.state.availableCultures[key]
        } else {
          tmp.selected[key] = self.$store.state.availableCultures[key]
        }
      }
      return tmp
    }
  },
  methods: {
    deleteCulture: function (culture) {
      var self = this
      var value = self.cultures.selected[culture]
      self.confirm({
        message: self.$resx('Global.AreYouSure') + value.EnglishName,
        buttons: [
          {
            name: self.$resx('Buttons.Cancel'),
            class: 'is-pulled-left',
            action: function () {
            }
          },
          {
            name: self.$resx('Buttons.Yes'),
            class: 'is-pulled-right is-danger',
            action: function () {
              self.$http({
                method: 'DELETE',
                url: '/culture/' + culture,
                name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
                api: 'website'
              }).then(function (response) {
                // self.$store.dispatch('deleteDownload', download)
                // self.$store.dispatch('setSnack', {
                //   message: 'Pagina <b>' + download + '</b> verwijderd',
                //   color: 'danger'
                // })
                // self.selected = -1
              }).catch(function (err) {
                self.$store.dispatch('setSnack', {
                  message: err.message
                })
              })
            }
          }
        ]
      })
    },
    selectCulture: function () {
      var self = this
      var value = self.cultures.available[self.cultureValue]
      self.confirm({
        message: self.$resx('Global.AreYouSure') + value.EnglishName,
        buttons: [
          {
            name: self.$resx('Buttons.Cancel'),
            class: 'is-pulled-left',
            action: function () {
              self.cultureValue = ''
            }
          },
          {
            name: self.$resx('Buttons.Yes'),
            class: 'is-pulled-right is-danger',
            action: function () {
              self.$http({
                method: 'POST',
                url: '/culture',
                name: process.env.VUE_APP_NAME + '_' + self.$store.state.language,
                api: 'website',
                data: JSON.stringify({ 'ID': self.cultureValue }),
                headers: {
                  'Content-Type': 'application/json'
                }
              }).then(function (response) {
                self.cultureValue = ''
                // self.$store.dispatch('deleteDownload', download)
                // self.$store.dispatch('setSnack', {
                //   message: 'Pagina <b>' + download + '</b> verwijderd',
                //   color: 'danger'
                // })
                // self.selected = -1
              }).catch(function (err) {
                self.cultureValue = ''
                self.$store.dispatch('setSnack', {
                  message: err.message
                })
              })
            }
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.cultures{
  >span{
    display: inline-block;
    position: relative;
     + span{
       margin-left: 10px;
     }
     >svg{
       opacity: 0;
       position: absolute;
       top: 5px;
       width: 100%;
       left: 0;
       text-align: center;
       transition: all 150ms ease-in-out;
     }
     >span{
       transition: all 150ms ease-in-out;
     }
     &:hover{
       cursor: pointer;
       >span{
         opacity: 0.2;
       }
       >svg{
         opacity: 1;
       }
     }
  }
}
</style>
